import { objectSpread2 as _objectSpread2 } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import sendGAEvent from './sendGAEvent.js';

var _window;
var currentUrl = typeof window !== 'undefined' && ((_window = window) === null || _window === void 0 || (_window = _window.location) === null || _window === void 0 ? void 0 : _window.href);
var BREADCRUMB = {
  LINK: 'breadcrumb__link'
};
var PACKAGE_CARD = {
  handleClick: function handleClick(packageName, requestId) {
    sendGAEvent('package_card_clicks.sgl', {
      package_name: packageName,
      page_url: currentUrl,
      requestId: requestId
    });
  }
};
var FOOTER = {
  LINKS: {
    handleClick: function handleClick(destination, linkText, requestId) {
      sendGAEvent('footer_clicks.sgl', {
        current_url: currentUrl,
        destination: destination,
        link_text: linkText,
        requestId: requestId
      });
    }
  }
};
var LINK_BUTTON = {
  handleClick: function handleClick(text, link, requestId) {
    sendGAEvent('cta_button_clicks.sgl', {
      button_text: text,
      href: link,
      current_url: currentUrl,
      requestId: requestId
    });
  }
};
var HEADER = {
  LOGO: {
    NAME: 'logo_clicks_to_home.sgl'
  },
  LINKS: {
    PHONE_LINK: 'header__phone-link.sgl',
    LEFT_PHONE_LINK: 'header__left-phone-link.sgl',
    handleClick: function handleClick(text, link, requestId) {
      sendGAEvent('header-nav-clicks.sgl', {
        link_text: text,
        destination: link,
        page_url: currentUrl,
        requestId: requestId
      });
    }
  }
};
var FORM = {
  handleClick: function handleClick(values, requestId) {
    var _values$address, _window2;
    sendGAEvent('long-form_submissions.sgl', _objectSpread2(_objectSpread2({}, values), {}, {
      address: values === null || values === void 0 || (_values$address = values.address) === null || _values$address === void 0 ? void 0 : _values$address.value,
      current_url: typeof window !== 'undefined' && ((_window2 = window) === null || _window2 === void 0 || (_window2 = _window2.location) === null || _window2 === void 0 ? void 0 : _window2.href),
      requestId: requestId
    }));
  },
  AVAILABILITY: {
    handleClick: function handleClick(zipcode, submitButtonText, requestId) {
      var _window3;
      sendGAEvent('zip-form_submissons.sgl', {
        zipcode: zipcode,
        submit_button_text: submitButtonText,
        current_url: typeof window !== 'undefined' && ((_window3 = window) === null || _window3 === void 0 || (_window3 = _window3.location) === null || _window3 === void 0 ? void 0 : _window3.href),
        requestId: requestId
      });
    },
    SUCCESS: {
      handleClick: function handleClick(zipcode, submitButtonText, requestId) {
        var _window4;
        sendGAEvent('zip-form_success.sgl', {
          zipcode: zipcode,
          submit_button_text: submitButtonText,
          current_url: typeof window !== 'undefined' && ((_window4 = window) === null || _window4 === void 0 || (_window4 = _window4.location) === null || _window4 === void 0 ? void 0 : _window4.href),
          requestId: requestId
        });
      }
    },
    FAILED: {
      handleClick: function handleClick(zipcode, submitButtonText, requestId) {
        var _window5;
        sendGAEvent('zip-form_failure.sgl', {
          zipcode: zipcode,
          submit_button_text: submitButtonText,
          current_url: typeof window !== 'undefined' && ((_window5 = window) === null || _window5 === void 0 || (_window5 = _window5.location) === null || _window5 === void 0 ? void 0 : _window5.href),
          requestId: requestId
        });
      }
    }
  }
};
var ACCORDION = {
  handleClick: function handleClick(question, requestId) {
    sendGAEvent('popular_faqs.sgl', {
      question: question,
      page_url: currentUrl,
      requestId: requestId
    });
  }
};
var MODAL = {
  NAME: 'change_location_modal.sgl'
};
var ANCHOR = {
  NAME: 'destination_urls.sgl'
};
var CTABAR = {
  NAME: 'sticky-cta-bar__phone'
};

export { ACCORDION, ANCHOR, BREADCRUMB, CTABAR, FOOTER, FORM, HEADER, LINK_BUTTON, MODAL, PACKAGE_CARD };
//# sourceMappingURL=dataTrackingValues.js.map
